export default "__VITE_ASSET__BXK5AbMa__"